function initToasty(root) {
 root.querySelectorAll('.ts-edit-product').forEach(function(el) {
  if(el.dataset.ready) return;
  const configNode=el.querySelector('.ts-commerce');
  if(!configNode) return;
  el.dataset.ready='true';
  const config=JSON.parse(configNode.textContent);
  const button=el.querySelector('.ts-preview');
  const error=el.querySelector('.ts-checkout-error');
  const recovery=el.querySelector('.ts-cart-recovery');
  const radios=Array.from(el.querySelectorAll('[name="ts-colour"]'));
  const names=radios.map(r=>r.dataset.name);
  const mix=el.querySelector('.ts-mix');
  const selects=Array.from(mix.querySelectorAll('select'));
  const upsell=el.querySelector('.ts-upsell-check');
  const money=c=>new Intl.NumberFormat(document.documentElement.lang||'en-CA',{style:'currency',currency:config.currency}).format(c/100);
  let busy=false;
  let added=false;
  function chosen(count) {
   return count===1?[Number(el.querySelector('[name="ts-colour"]:checked').value)]:selects.slice(0,count).map(s=>Number(s.value));
  }
  function update() {
   const pack=el.querySelector('[name="ts-pack"]:checked');
   const count=Number(pack.value);
   const indices=chosen(count);
   const variants=indices.map(i=>config.variants[i]);
   const withPower=Boolean(upsell&&upsell.checked);
   const valid=variants.every(v=>v&&v.id&&v.available)&&(!withPower||(config.power.id&&config.power.available));
   const total=variants.reduce((n,v)=>n+(v?v.price:0),0)+(withPower?config.power.price:0);
   el.querySelectorAll('.ts-total').forEach(n=>n.textContent=money(total));
   const single=config.variants[Number(el.querySelector('[name="ts-colour"]:checked').value)];
   el.querySelector('.ts-live-single').textContent=money(single.price);
   const compare=el.querySelector('.ts-price .ts-live-compare');
   compare.textContent=single.compare>single.price?money(single.compare):'';
   el.querySelectorAll('[name="ts-pack"]').forEach(r=>{
    const items=chosen(Number(r.value)).map(i=>config.variants[i]);
    const price=items.reduce((n,v)=>n+v.price,0);
    const comparePrice=items.reduce((n,v)=>n+(v.compare||v.price),0);
    r.closest('label').querySelector('.ts-pack-price b').textContent=money(price);
    r.closest('label').querySelector('.ts-pack-price s').textContent=comparePrice>price?money(comparePrice):'';
   });
   button.disabled=busy||!valid;
   if(!busy&&!added){error.hidden=valid;error.textContent=valid?'':config.labels.unavailable;recovery.hidden=true;}
  }
  radios.forEach((r,i)=>{r.disabled=!config.variants[i].available;});
  selects.forEach(s=>Array.from(s.options).forEach(o=>o.disabled=!config.variants[Number(o.value)].available));
  const availableIndex=config.variants.findIndex(v=>v.id&&v.available);
  if(availableIndex>=0){
   if(!config.variants[Number(el.querySelector('[name="ts-colour"]:checked').value)].available) radios[availableIndex].checked=true;
   selects.forEach(s=>{if(!config.variants[Number(s.value)].available)s.value=String(availableIndex);});
  }
  function show(index) {
   el.querySelectorAll('.ts-slide').forEach((slide,i)=>slide.hidden=i!==index);
   el.querySelectorAll('[data-slide]').forEach(b=>b.setAttribute('aria-pressed',String(Number(b.dataset.slide)===index)));
   if(index<names.length&&config.variants[index].available){
    radios.forEach(r=>r.checked=Number(r.value)===index);
    el.querySelector('.ts-selected-colour').textContent=names[index];
    selects[0].value=String(index);
   }
   update();
  }
  el.querySelectorAll('[data-slide]').forEach(b=>b.addEventListener('click',()=>show(Number(b.dataset.slide))));
  radios.forEach(r=>r.addEventListener('change',()=>show(Number(r.value))));
  function arrangePack() {
   const r=el.querySelector('[name="ts-pack"]:checked');
   r.closest('label').insertAdjacentElement('afterend',mix);
   mix.hidden=r.value==='1';
   mix.querySelectorAll('[data-item]').forEach(n=>n.hidden=Number(n.dataset.item)>Number(r.value));
   update();
  }
  el.querySelectorAll('[name="ts-pack"]').forEach(r=>r.addEventListener('change',arrangePack));
  selects.forEach(s=>s.addEventListener('change',update));
  if(upsell)upsell.addEventListener('change',update);
  const normalButton=button.innerHTML;
  button.addEventListener('click',async function(){
   if(busy) return;
   if(added){window.location.assign(config.cartUrl);return;}
   const count=Number(el.querySelector('[name="ts-pack"]:checked').value);
   const variants=chosen(count).map(i=>config.variants[i]);
   if(upsell&&upsell.checked)variants.push(config.power);
   if(variants.some(v=>!v.id||!v.available)){update();return;}
   const quantities=new Map();
   variants.forEach(v=>quantities.set(v.id,(quantities.get(v.id)||0)+1));
   const items=Array.from(quantities,([id,quantity])=>({id,quantity}));
   busy=true;button.disabled=true;button.setAttribute('aria-busy','true');
   button.textContent=config.labels.busy;error.hidden=true;
   try {
    const response=await fetch(config.addUrl,{method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items})});
    const data=await response.json();
    if(!response.ok)throw new Error(typeof data.description==='string'?data.description:config.labels.error);
    added=true;
    const root=config.root.endsWith('/')?config.root:config.root+'/';
    window.location.assign(root+'checkout');
   } catch(e) {
    error.textContent=e instanceof TypeError?config.labels.error:(e.message||config.labels.error);
    error.hidden=false;recovery.hidden=false;
    button.innerHTML=normalButton;busy=false;button.disabled=false;button.removeAttribute('aria-busy');
    el.querySelectorAll('.ts-total').forEach(n=>n.textContent=money(variants.reduce((n,v)=>n+v.price,0)));
   }
  });
  const initialIndex=config.variants.findIndex(v=>String(v.id)===String(config.initialVariantId));
  if(initialIndex>=0)show(initialIndex);
  arrangePack();
  window.addEventListener('pageshow',function(e){if(e.persisted){busy=false;added=true;button.disabled=false;button.removeAttribute('aria-busy');button.textContent=recovery.textContent;recovery.hidden=false;}});
 });
}
initToasty(document);
document.addEventListener('shopify:section:load',e=>initToasty(e.target));
document.addEventListener('click',function(e){
 const picker=e.target.closest('[data-pick-colour]');
 if(picker){const radio=document.querySelector('.ts-edit-product [name="ts-colour"][value="'+picker.dataset.pickColour+'"]');if(radio&&!radio.disabled){radio.checked=true;radio.dispatchEvent(new Event('change',{bubbles:true}));}}
});